import { ThemeConfig } from 'react-select/src/theme';

export const theme: ThemeConfig = (theme) => ({...theme, colors: { ...theme['colors'], primary: '#94ad34', primary75: '#c2cc9c', primary50: '#d5dfb3', primary25: '#e3eec0' } });